import React, {useEffect, useRef, useState} from 'react';
import './EditableField.css';
const EditableField = ({field, onChange, value, error, disabled}) => {
  const {id, label, type} = field;
  const [isEdited, setIsEdited] = useState(false);
  const inputRef = useRef(null);
  const handleClickEdit = () => {
    if (!isEdited && disabled) {
      setIsEdited(true);
    }
  };

  const onBlur = () => {
    setIsEdited(false);
  };
  const handleChange = (e) => {
    const {value} = e.currentTarget;
    onChange(value); // Используем field.name вместо e.currentTarget.name
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setIsEdited(false);
    }
  };
  useEffect(() => {
    if (isEdited) {
      inputRef.current?.focus();
    }
  }, [isEdited]);
  return (
    <div
      onClick={handleClickEdit}
      className='editable-field__content-block editable-field__field-text editable-field__content-block-edit'
      data-animate='show'
      data-cid={id}
    >
      <div
        data-field-tag={id}
        className='editable-field__block-before-action'
      ></div>
      <div className='editable-field__block-draggable-btn-container'>
        <div className='editable-field__draggable-btn'></div>
      </div>
      <div className='editable-field__block-title '>
        <label className='editable-field__block-title-text' htmlFor={id}>
          {label}
        </label>
      </div>
      {!isEdited ? (
        <div className='editable-field__content-block'>
          <div className='editable-field__content-block-content'>
            {value ? value : 'не заполнено'}
            {disabled && <div className='editable-field__block-context-menu' />}
          </div>
          {error && <p className='editable-field__error-message'>{error}</p>}
        </div>
      ) : (
        <div className='editable-field__content-block'>
          <input
            ref={inputRef}
            className='editable-field__input'
            type={type}
            readOnly={!disabled}
            id={id}
            name={id}
            onBlur={onBlur}
            value={value || ''}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          {error && <p className='auth-forms__error-message'>{error}</p>}
        </div>
      )}
    </div>
  );
};

export default EditableField;
